/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Controller, ControllerInterface } from "../Controller";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPNS",
        name: "pns",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_baseNode",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "_basePrices",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_rentPrices",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "_priceFeed",
        type: "address",
      },
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "capacity",
        type: "uint256",
      },
    ],
    name: "CapacityUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "flags",
        type: "uint256",
      },
    ],
    name: "ConfigUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "manager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bool",
        name: "role",
        type: "bool",
      },
    ],
    name: "ManagerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "node",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "expires",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "NameRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "node",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "expires",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "NameRenewed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256[]",
        name: "basePrices",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "rentPrices",
        type: "uint256[]",
      },
    ],
    name: "PriceChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldRoot",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newRoot",
        type: "address",
      },
    ],
    name: "RootOwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "BASE_NODE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FLAGS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MIN_REGISTRATION_DURATION",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MIN_REGISTRATION_LENGTH",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_pns",
    outputs: [
      {
        internalType: "contract IPNS",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "basePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPrices",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTokenPrice",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "isManager",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "duration",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "code",
        type: "bytes",
      },
    ],
    name: "nameRedeem",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "duration",
        type: "uint64",
      },
    ],
    name: "nameRegister",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "duration",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "data",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "keyHashes",
        type: "uint256[]",
      },
      {
        internalType: "string[]",
        name: "values",
        type: "string[]",
      },
    ],
    name: "nameRegisterByManager",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "duration",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "data",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "keyHashes",
        type: "uint256[]",
      },
      {
        internalType: "string[]",
        name: "values",
        type: "string[]",
      },
    ],
    name: "nameRegisterWithConfig",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "priceFeed",
    outputs: [
      {
        internalType: "contract AggregatorV3Interface",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "datahash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "code",
        type: "bytes",
      },
    ],
    name: "recoverKey",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "uint64",
        name: "duration",
        type: "uint64",
      },
    ],
    name: "renew",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "uint64",
        name: "duration",
        type: "uint64",
      },
    ],
    name: "renewByManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "uint64",
        name: "duration",
        type: "uint64",
      },
    ],
    name: "renewPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "uint64",
        name: "duration",
        type: "uint64",
      },
    ],
    name: "rentPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "root",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_flags",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_min_length",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_min_duration",
        type: "uint64",
      },
      {
        internalType: "address",
        name: "_price_feed",
        type: "address",
      },
    ],
    name: "setContractConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "manager",
        type: "address",
      },
      {
        internalType: "bool",
        name: "role",
        type: "bool",
      },
    ],
    name: "setManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_basePrices",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_rentPrices",
        type: "uint256[]",
      },
    ],
    name: "setPrices",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "uint64",
        name: "duration",
        type: "uint64",
      },
    ],
    name: "totalRegisterPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferRootOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Controller__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    pns: string,
    _baseNode: BigNumberish,
    _basePrices: BigNumberish[],
    _rentPrices: BigNumberish[],
    _priceFeed: string,
    forwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Controller> {
    return super.deploy(
      pns,
      _baseNode,
      _basePrices,
      _rentPrices,
      _priceFeed,
      forwarder,
      overrides || {}
    ) as Promise<Controller>;
  }
  getDeployTransaction(
    pns: string,
    _baseNode: BigNumberish,
    _basePrices: BigNumberish[],
    _rentPrices: BigNumberish[],
    _priceFeed: string,
    forwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      pns,
      _baseNode,
      _basePrices,
      _rentPrices,
      _priceFeed,
      forwarder,
      overrides || {}
    );
  }
  attach(address: string): Controller {
    return super.attach(address) as Controller;
  }
  connect(signer: Signer): Controller__factory {
    return super.connect(signer) as Controller__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ControllerInterface {
    return new utils.Interface(_abi) as ControllerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Controller {
    return new Contract(address, _abi, signerOrProvider) as Controller;
  }
}
